module.exports = __webpack_public_path__ + "static/media/ic_primary_filter.b313798d.svg";